import { useContext, useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

// Contexts
import { MeContext } from 'contexts/me'
import { MovementsContext } from 'contexts/movements'

// Page components
import MovementsListContainer from 'components/movements/MovementsListContainer'

const ReceiptsTab = () => {
  const { callActivities } = useContext(MovementsContext)
  const { me } = useContext(MeContext)

  useEffect(() => {
    if (!me) return
    callActivities({
      walletUUID: me.bank.internal_account[0].wallet_account
    })
  }, [me])

  useEffect(() => {
    trackEvent({
      eventName: 'bille_boton_comprobantes_transferencia',
      withUTMParams: false
    })
  }, [])

  return <MovementsListContainer isTransfer />
}

export default ReceiptsTab
